import React from "react";
import { observer } from "mobx-react";
import { Box, Typography } from "@mui/material";
import { useRootStore } from "../../store/contexts/RootStoreContext";
import { InnerDrawer } from "./InnerDrawer";
import { UserDrawerContent } from "../../entities/user/components/view/UserDrawerContent";
import { RoleDrawerContent } from "../../entities/role/components/view/RoleDrawerContent";
import { PermissionDrawerContent } from "../../entities/permission/components/view/PermissionDrawerContent";
import { TenantDrawerContent } from "../../entities/tenant/components/view/TenantDrawerContent";
import { TenantProfileDrawerContent } from "../../entities/tenantProfile/components/view/TenantProfileDrawerContent";
import { VatStatusDrawerContent } from "../../entities/vatStatus/components/view/VatStatusDrawerContent";
import { GrossReceiptsStatusDrawerContent } from "../../entities/grossReceiptsStatus/components/view/GrossReceiptsStatusDrawerContent";
import { TenantTypeDrawerContent } from "../../entities/tenantType/components/view/TenantTypeDrawerContent";
import { TenantStatusDrawerContent } from "../../entities/tenantStatus/components/view/TenantStatusDrawerContent";
import { CurrencyDrawerContent } from "../../entities/currency/components/view/CurrencyDrawerContent";
import { TenantPlanDrawerContent } from "../../entities/tenantPlan/components/view/TenantPlanDrawerContent";
import { CountryDrawerContent } from "../../entities/country/components/view/CountryDrawerContent";
import { ProvinceStateDrawerContent } from "../../entities/provinceState/components/view/ProvinceStateDrawerContent";
import { CreditTierDrawerContent } from "../../entities/creditTier/components/view/CreditTierDrawerContent";
import { CreditAccountDrawerContent } from "../../entities/creditAccount/components/view/CreditAccountDrawerContent";
import { CreditPurchaseDrawerContent } from "../../entities/creditPurchase/components/view/CreditPurchaseDrawerContent";
import { CreditMovementDrawerContent } from "../../entities/creditMovement/components/view/CreditMovementDrawerContent";
import { WorkerEventDrawerContent } from "../../entities/workerEvent/components/view/WorkerEventDrawerContent";
import { SimulationSessionDrawerContent } from "../../entities/simulationSession/components/view/SimulationSessionDrawerContent";
import { SnapshotOverrideDrawerContent } from "../../entities/snapshotOverride/components/view/SnapshotOverrideDrawerContent";
import { BotRunDrawerContent } from "../../entities/botRun/components/view/BotRunDrawerContent";
import { BotPhaseDrawerContent } from "../../entities/botPhase/components/view/BotPhaseDrawerContent";
import { BotStepDrawerContent } from "../../entities/botStep/components/view/BotStepDrawerContent";
import { BotErrorDrawerContent } from "../../entities/botError/components/view/BotErrorDrawerContent";
import { SatelliteMachineDrawerContent } from "../../entities/satelliteMachine/components/view/SatelliteMachineDrawerContent";
import { SatelliteTaskDrawerContent } from "../../entities/satelliteTask/components/view/SatelliteTaskDrawerContent";
import { SatelliteHeartbeatDrawerContent } from "../../entities/satelliteHeartbeat/components/view/SatelliteHeartbeatDrawerContent";
import { DashboardWidgetDrawerContent } from "../../entities/dashboardWidget/components/view/DashboardWidgetDrawerContent";
import { TenantWidgetAccessDrawerContent } from "../../entities/tenantWidgetAccess/components/view/TenantWidgetAccessDrawerContent";
import { UserWidgetConfigDrawerContent } from "../../entities/userWidgetConfig/components/view/UserWidgetConfigDrawerContent";
import { DashboardLayoutTemplateDrawerContent } from "../../entities/dashboardLayoutTemplate/components/view/DashboardLayoutTemplateDrawerContent";
import { ReportDrawerContent } from "../../entities/report/components/view/ReportDrawerContent";
import { ReportTypeDrawerContent } from "../../entities/reportType/components/view/ReportTypeDrawerContent";
import { UserNotificationDrawerContent } from "../../entities/userNotification/components/view/UserNotificationDrawerContent";
import { UserNotificationPreferenceDrawerContent } from "../../entities/userNotificationPreference/components/view/UserNotificationPreferenceDrawerContent";
import { AlertRuleDrawerContent } from "../../entities/alertRule/components/view/AlertRuleDrawerContent";
import { AlertSubscriptionDrawerContent } from "../../entities/alertSubscription/components/view/AlertSubscriptionDrawerContent";
import { EmailVerificationDrawerContent } from "../../entities/emailVerification/components/view/EmailVerificationDrawerContent";
import { ShowcaseWorkflowStateDrawerContent } from "../../entities/showcaseWorkflowState/components/view/ShowcaseWorkflowStateDrawerContent";
import { ShowcaseCategoryDrawerContent } from "../../entities/showcaseCategory/components/view/ShowcaseCategoryDrawerContent";
import { ShowcaseLineDrawerContent } from "../../entities/showcaseLine/components/view/ShowcaseLineDrawerContent";
import { DesignShowcaseDrawerContent } from "../../entities/designShowcase/components/view/DesignShowcaseDrawerContent";
import { ThemeDrawerContent } from "../../entities/theme/components/view/ThemeDrawerContent";
import { AuthorComposerDrawerContent } from "../../entities/authorComposer/components/view/AuthorComposerDrawerContent";
import { CollectiveManagementSocietyDrawerContent } from "../../entities/collectiveManagementSociety/components/view/CollectiveManagementSocietyDrawerContent";
import { AuthorCollectingSocietyDrawerContent } from "../../entities/authorCollectingSociety/components/view/AuthorCollectingSocietyDrawerContent";
import { PublisherDrawerContent } from "../../entities/publisher/components/view/PublisherDrawerContent";
import { AuthorPublisherDrawerContent } from "../../entities/authorPublisher/components/view/AuthorPublisherDrawerContent";
import { WorkAuthorPublisherDrawerContent } from "../../entities/workAuthorPublisher/components/view/WorkAuthorPublisherDrawerContent";
import { PublisherCollectingSocietyDrawerContent } from "../../entities/publisherCollectingSociety/components/view/PublisherCollectingSocietyDrawerContent";
import { PublisherRepresentativeDrawerContent } from "../../entities/publisherRepresentative/components/view/PublisherRepresentativeDrawerContent";
import { EditionTypeDrawerContent } from "../../entities/editionType/components/view/EditionTypeDrawerContent";
import { MusicalWorkDrawerContent } from "../../entities/musicalWork/components/view/MusicalWorkDrawerContent";
import { PhonogramDrawerContent } from "../../entities/phonogram/components/view/PhonogramDrawerContent";
import { TerritoryDrawerContent } from "../../entities/territory/components/view/TerritoryDrawerContent";
import { MusicalWorkLinkDrawerContent } from "../../entities/musicalWorkLink/components/view/MusicalWorkLinkDrawerContent";
import { PlatformDrawerContent } from "../../entities/platform/components/view/PlatformDrawerContent";
import { PlatformLinkTypeDrawerContent } from "../../entities/platformLinkType/components/view/PlatformLinkTypeDrawerContent";
import { WorkAuthorDrawerContent } from "../../entities/workAuthor/components/view/WorkAuthorDrawerContent";
import { EditionDrawerContent } from "../../entities/edition/components/view/EditionDrawerContent";
import { SignedEditionDrawerContent } from "../../entities/signedEdition/components/view/SignedEditionDrawerContent";
import { EditionContractPublisherDrawerContent } from "../../entities/editionContractPublisher/components/view/EditionContractPublisherDrawerContent";
import { EditionDocumentationDrawerContent } from "../../entities/editionDocumentation/components/view/EditionDocumentationDrawerContent";
import { SignedContractDrawerContent } from "../../entities/signedContract/components/view/SignedContractDrawerContent";
import { EditionDocumentTypeDrawerContent } from "../../entities/editionDocumentType/components/view/EditionDocumentTypeDrawerContent";
import { AssociatedDocumentEditionDrawerContent } from "../../entities/associatedDocumentEdition/components/view/AssociatedDocumentEditionDrawerContent";
import { AssociatedDocumentSignedEditionDrawerContent } from "../../entities/associatedDocumentSignedEdition/components/view/AssociatedDocumentSignedEditionDrawerContent";
import { SignedEditionBlockchainCertDrawerContent } from "../../entities/signedEditionBlockchainCert/components/view/SignedEditionBlockchainCertDrawerContent";
import { UserAttachmentEditionDrawerContent } from "../../entities/userAttachmentEdition/components/view/UserAttachmentEditionDrawerContent";
import { InterpreterDrawerContent } from "../../entities/interpreter/components/view/InterpreterDrawerContent";
import { MusicalGenreDrawerContent } from "../../entities/musicalGenre/components/view/MusicalGenreDrawerContent";
import { ContractObservationDrawerContent } from "../../entities/contractObservation/components/view/ContractObservationDrawerContent";
import { PaymentReceiptTypeDrawerContent } from "../../entities/paymentReceiptType/components/view/PaymentReceiptTypeDrawerContent";
import { PaymentReceiptUseDrawerContent } from "../../entities/paymentReceiptUse/components/view/PaymentReceiptUseDrawerContent";
import { PaymentReceiptDrawerContent } from "../../entities/paymentReceipt/components/view/PaymentReceiptDrawerContent";
import { TadManagerConfigDrawerContent } from "../../entities/tadManagerConfig/components/view/TadManagerConfigDrawerContent";
import { DocumentGenerationParamsDrawerContent } from "../../entities/documentGenerationParams/components/view/DocumentGenerationParamsDrawerContent";
import { EditionDocumentationWorkflowStateDrawerContent } from "../../entities/editionDocumentationWorkflowState/components/view/EditionDocumentationWorkflowStateDrawerContent";
import { SignedEditionDndaWorkflowStateDrawerContent } from "../../entities/signedEditionDndaWorkflowState/components/view/SignedEditionDndaWorkflowStateDrawerContent";
import { SignedEditionSadaicWorkflowStateDrawerContent } from "../../entities/signedEditionSadaicWorkflowState/components/view/SignedEditionSadaicWorkflowStateDrawerContent";
import { LlmProviderDrawerContent } from "../../entities/llmProvider/components/view/LlmProviderDrawerContent";
import { TenantLlmConfigDrawerContent } from "../../entities/tenantLlmConfig/components/view/TenantLlmConfigDrawerContent";
import { TenantDocumentDrawerContent } from "../../entities/tenantDocument/components/view/TenantDocumentDrawerContent";
import { AiSearchConversationDrawerContent } from "../../entities/aiSearchConversation/components/view/AiSearchConversationDrawerContent";
import { AiSearchResponseDrawerContent } from "../../entities/aiSearchResponse/components/view/AiSearchResponseDrawerContent";
import { AiSearchToolCallDrawerContent } from "../../entities/aiSearchToolCall/components/view/AiSearchToolCallDrawerContent";
import { TenantTokenUsageDrawerContent } from "../../entities/tenantTokenUsage/components/view/TenantTokenUsageDrawerContent";
import { TenantStorageUsageDrawerContent } from "../../entities/tenantStorageUsage/components/view/TenantStorageUsageDrawerContent";
import { AiSearchAutoEvalDrawerContent } from "../../entities/aiSearchAutoEval/components/view/AiSearchAutoEvalDrawerContent";
import { AiSearchPatternDrawerContent } from "../../entities/aiSearchPattern/components/view/AiSearchPatternDrawerContent";
import { EvaluationQueryDrawerContent } from "../../entities/evaluationQuery/components/view/EvaluationQueryDrawerContent";
import { QueryPatternDrawerContent } from "../../entities/queryPattern/components/view/QueryPatternDrawerContent";
import { EsignatureConfigDrawerContent } from "../../entities/esignatureConfig/components/view/EsignatureConfigDrawerContent";
import { EsignatureDocumentDrawerContent } from "../../entities/esignatureDocument/components/view/EsignatureDocumentDrawerContent";
import { EsignatureRecipientDrawerContent } from "../../entities/esignatureRecipient/components/view/EsignatureRecipientDrawerContent";
import { EsignatureWebhookEventDrawerContent } from "../../entities/esignatureWebhookEvent/components/view/EsignatureWebhookEventDrawerContent";

export const DrawerView: React.FC = observer(() => {
  const rootStore = useRootStore();
  const { prefStore } = rootStore;
  const { drawerViewOpen, drawerViewStack } = rootStore;

  if (!drawerViewOpen || drawerViewStack.length === 0) {
    return null;
  }

  const currentView = drawerViewStack[drawerViewStack.length - 1];

  const renderContent = () => {
    switch (currentView.entityType) {
      case "user":
        return (
          <UserDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "role":
        return (
          <RoleDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "permission":
        return (
          <PermissionDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenant":
        return (
          <TenantDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenantProfile":
        return (
          <TenantProfileDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "vatStatus":
        return (
          <VatStatusDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "grossReceiptsStatus":
        return (
          <GrossReceiptsStatusDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenantType":
        return (
          <TenantTypeDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenantStatus":
        return (
          <TenantStatusDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "currency":
        return (
          <CurrencyDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenantPlan":
        return (
          <TenantPlanDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "country":
        return (
          <CountryDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "provinceState":
        return (
          <ProvinceStateDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "creditTier":
        return (
          <CreditTierDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "creditAccount":
        return (
          <CreditAccountDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "creditPurchase":
        return (
          <CreditPurchaseDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "creditMovement":
        return (
          <CreditMovementDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "workerEvent":
        return (
          <WorkerEventDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "simulationSession":
        return (
          <SimulationSessionDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "snapshotOverride":
        return (
          <SnapshotOverrideDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "botRun":
        return (
          <BotRunDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "botPhase":
        return (
          <BotPhaseDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "botStep":
        return (
          <BotStepDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "botError":
        return (
          <BotErrorDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "satelliteMachine":
        return (
          <SatelliteMachineDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "satelliteTask":
        return (
          <SatelliteTaskDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "satelliteHeartbeat":
        return (
          <SatelliteHeartbeatDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "dashboardWidget":
        return (
          <DashboardWidgetDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenantWidgetAccess":
        return (
          <TenantWidgetAccessDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "userWidgetConfig":
        return (
          <UserWidgetConfigDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "dashboardLayoutTemplate":
        return (
          <DashboardLayoutTemplateDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "report":
        return (
          <ReportDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "reportType":
        return (
          <ReportTypeDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "userNotification":
        return (
          <UserNotificationDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "userNotificationPreference":
        return (
          <UserNotificationPreferenceDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "alertRule":
        return (
          <AlertRuleDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "alertSubscription":
        return (
          <AlertSubscriptionDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "emailVerification":
        return (
          <EmailVerificationDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "showcaseWorkflowState":
        return (
          <ShowcaseWorkflowStateDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "showcaseCategory":
        return (
          <ShowcaseCategoryDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "showcaseLine":
        return (
          <ShowcaseLineDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "designShowcase":
        return (
          <DesignShowcaseDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "theme":
        return (
          <ThemeDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "authorComposer":
        return (
          <AuthorComposerDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "collectiveManagementSociety":
        return (
          <CollectiveManagementSocietyDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "authorCollectingSociety":
        return (
          <AuthorCollectingSocietyDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "publisher":
        return (
          <PublisherDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "authorPublisher":
        return (
          <AuthorPublisherDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "workAuthorPublisher":
        return (
          <WorkAuthorPublisherDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "publisherCollectingSociety":
        return (
          <PublisherCollectingSocietyDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "publisherRepresentative":
        return (
          <PublisherRepresentativeDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "editionType":
        return (
          <EditionTypeDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "musicalWork":
        return (
          <MusicalWorkDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "phonogram":
        return (
          <PhonogramDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "territory":
        return (
          <TerritoryDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "musicalWorkLink":
        return (
          <MusicalWorkLinkDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "platform":
        return (
          <PlatformDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "platformLinkType":
        return (
          <PlatformLinkTypeDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "workAuthor":
        return (
          <WorkAuthorDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "edition":
        return (
          <EditionDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "signedEdition":
        return (
          <SignedEditionDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "editionContractPublisher":
        return (
          <EditionContractPublisherDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "editionDocumentation":
        return (
          <EditionDocumentationDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "signedContract":
        return (
          <SignedContractDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "editionDocumentType":
        return (
          <EditionDocumentTypeDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "associatedDocumentEdition":
        return (
          <AssociatedDocumentEditionDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "associatedDocumentSignedEdition":
        return (
          <AssociatedDocumentSignedEditionDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "signedEditionBlockchainCert":
        return (
          <SignedEditionBlockchainCertDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "userAttachmentEdition":
        return (
          <UserAttachmentEditionDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "interpreter":
        return (
          <InterpreterDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "musicalGenre":
        return (
          <MusicalGenreDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "contractObservation":
        return (
          <ContractObservationDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "paymentReceiptType":
        return (
          <PaymentReceiptTypeDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "paymentReceiptUse":
        return (
          <PaymentReceiptUseDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "paymentReceipt":
        return (
          <PaymentReceiptDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tadManagerConfig":
        return (
          <TadManagerConfigDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "documentGenerationParams":
        return (
          <DocumentGenerationParamsDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "editionDocumentationWorkflowState":
        return (
          <EditionDocumentationWorkflowStateDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "signedEditionDndaWorkflowState":
        return (
          <SignedEditionDndaWorkflowStateDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "signedEditionSadaicWorkflowState":
        return (
          <SignedEditionSadaicWorkflowStateDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "llmProvider":
        return (
          <LlmProviderDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenantLlmConfig":
        return (
          <TenantLlmConfigDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenantDocument":
        return (
          <TenantDocumentDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "aiSearchConversation":
        return (
          <AiSearchConversationDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "aiSearchResponse":
        return (
          <AiSearchResponseDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "aiSearchToolCall":
        return (
          <AiSearchToolCallDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenantTokenUsage":
        return (
          <TenantTokenUsageDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "tenantStorageUsage":
        return (
          <TenantStorageUsageDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "aiSearchAutoEval":
        return (
          <AiSearchAutoEvalDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "aiSearchPattern":
        return (
          <AiSearchPatternDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "evaluationQuery":
        return (
          <EvaluationQueryDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "queryPattern":
        return (
          <QueryPatternDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "esignatureConfig":
        return (
          <EsignatureConfigDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "esignatureDocument":
        return (
          <EsignatureDocumentDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "esignatureRecipient":
        return (
          <EsignatureRecipientDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "esignatureWebhookEvent":
        return (
          <EsignatureWebhookEventDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "site-user":
        return (
          <UserDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "my-credit-purchases":
        return (
          <CreditPurchaseDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      case "author-composer-public":
        return (
          <AuthorComposerDrawerContent
            entityId={currentView.entityId}
            mode={currentView.mode}
          />
        );
      default:
        return (
          <Typography>
            Entidad no encontrada: {currentView.entityType}
          </Typography>
        );
    }
  };

  return (
    <InnerDrawer
      open={drawerViewOpen}
      onClose={() => rootStore.closeDrawerView()}
      contentTop={prefStore.getCurrentContentTop()}
    >
      <Box sx={{ height: "100%", overflow: "auto" }}>{renderContent()}</Box>
    </InnerDrawer>
  );
});
